import { BaseEnumeration } from "@/enumerations/BaseEnumeration";
import BaseEnumerationMember from "@/enumerations/BaseEnumerationMember";
export default class PrepaidStatus extends BaseEnumeration<string> {
  public static all = new BaseEnumerationMember("All", " ");
  public static outstanding = new BaseEnumerationMember("Outstanding", "O");

  public GetContents(): BaseEnumerationMember<string>[] {
    return [PrepaidStatus.all, PrepaidStatus.outstanding];
  }
}
